import React from 'react';
import { Shield, Info, HelpCircle } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-cyber-dark-blue/80 backdrop-blur-md border-t border-cyber-blue/30 py-3 px-4 mt-auto">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center mb-3 md:mb-0">
            <Shield className="h-5 w-5 text-cyber-blue mr-2" />
            <span className="text-white text-sm">CyberShield © 2025</span>
          </div>
          
          <div className="flex items-center space-x-6 text-xs">
            <a href="#" className="text-cyber-light hover:text-cyber-blue transition-colors flex items-center">
              <Info className="h-4 w-4 mr-1" />
              Acerca de
            </a>
            <a href="#" className="text-cyber-light hover:text-cyber-blue transition-colors flex items-center">
              <HelpCircle className="h-4 w-4 mr-1" />
              Ayuda
            </a>
            <span className="text-cyber-light">
              Cumplimiento: ISO 27001 | GDPR | SOC 2
            </span>
          </div>
        </div>
        
        <div className="text-center mt-3">
          <p className="text-cyber-light text-xs">
            Encriptación AES-256 | SSL/TLS | Monitoreo 24/7 | Uptime 99.9%
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;